import * as actionTypes from "../actionTypes";
import jwt_decode from "jwt-decode";
import {FRONTEND_CONFIGURATION, TOKEN_NAME} from "../../shared/utils/constants/storage";
import {store} from "../store";
import {getIntegrationIdFromToken} from "../../shared/utils/storageUtils";
import AuthService from "../../api/authService";
import CustomerService from "../../api/customerService";
import RefreshCacheService from "../../api/refreshCacheService";

export const samlAuth = () => {
    return dispatch => {
        if (sessionStorage.getItem(TOKEN_NAME) && jwt_decode(sessionStorage.getItem(TOKEN_NAME)).exp > Date.now() / 1000) {
            let token = sessionStorage.getItem(TOKEN_NAME);
            let config = JSON.parse(sessionStorage.getItem(FRONTEND_CONFIGURATION))
            let decodedToken = jwt_decode(token)
            const integrationId = getIntegrationIdFromToken(token)
            cacheSimsAndDigitalContract(dispatch, integrationId)
            console.log("Token = " + token);
            console.log(decodedToken);
            dispatch({
                type: actionTypes.SET_LOGIN_PARAMS,
                token: token,
                frontendConfiguration: config,
                claims: decodedToken,
                integrationId
            });
        } else {
            if (sessionStorage.getItem(TOKEN_NAME)) {
                sessionStorage.removeItem(TOKEN_NAME);
            }
            console.log("No token in session storage");
            AuthService.getToken()
                .then((res) => {
                    const decodedToken = jwt_decode(res.data.token)
                    const integrationId = getIntegrationIdFromToken(res.data.token)
                    cacheSimsAndDigitalContract(dispatch, integrationId)
                    sessionStorage.setItem(TOKEN_NAME, res.data.token);
                    sessionStorage.setItem(FRONTEND_CONFIGURATION, JSON.stringify(res.data.frontendConfiguration))
                    dispatch({
                        type: actionTypes.SET_LOGIN_PARAMS,
                        token: res.data.token,
                        frontendConfiguration: res.data.frontendConfiguration,
                        integrationId,
                        claims: decodedToken
                    })
                    console.log(res.data.token);
                    console.log(decodedToken);
                })
        }
    }

}

export const fetchCompanies = (page, rowsPerPage, oldIntegrationId) => {
    let state = store.getState().authReducer.companies;
    return dispatch => {
        if (!state.loading) {
            dispatch(setLoading(true, "loading"));
            CustomerService.getCustomers(page, rowsPerPage, oldIntegrationId, state.searchText).then(res => {
                dispatch({
                    type: actionTypes.FETCH_COMPANIES,
                    data: res.data.data,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    count: res.data.count
                });
            }).catch(e => {
                console.log(e);
            }).then(() => {
                dispatch(setLoading(false, "loading"));
            })
        }
    }
}

export const setFilterCompanies = (value) => {
    return {
        type: actionTypes.SET_FILTER_COMPANIES,
        value: value
    }
}

export const setSelectedCompany = (integrationId) => {
    let stateCompanies = store.getState().authReducer.companies.data;
    let selectedCompany = stateCompanies.find(c => c.integrationId === integrationId);
    return dispatch => {
        dispatch(setLoading(true, "liveloAssistenzaLoading"));
        CustomerService.generateNewToken(integrationId).then((res) => {
            cacheSimsAndDigitalContract(dispatch, integrationId)
            const decodedToken = jwt_decode(res.data.token)
            selectedCompany = {
                ...selectedCompany,
                livelloDiAssistenza: res.data.cfgWsSrAssistenza.name,
                livelloDiAssistenzaId: res.data.cfgWsSrAssistenza.id,
                changeInSelf: res.data.changeInSelf,
                isConsipCustomer: decodedToken.isConsipCustomer,
            };
            dispatch({
                type: actionTypes.SET_SELECTED_COMPANY,
                selectedCompany: selectedCompany,
                token: res.data.token,
                frontendConfiguration: res.data.frontendConfiguration,
            })
        }).catch((err) => {
            console.log(err);
        }).then(() => {
            dispatch(setLoading(false, "liveloAssistenzaLoading"));
        });
    }
}

export const setParentCompany = (integrationId) => {
    return dispatch => {
        dispatch(setLoading(true, "liveloAssistenzaLoading"));
        CustomerService.getParentCompany(integrationId).then((res) => {
            cacheSimsAndDigitalContract(dispatch, integrationId)
            const selectedCompany = {
                name: res.data.customer.name,
                integrationId: integrationId,
                codiceFiscale: res.data.customer.codiceFiscale,
                piva: res.data.customer.piva,
                livelloDiAssistenza: res.data.authCredentials.cfgWsSrAssistenza.name,
                livelloDiAssistenzaId: res.data.authCredentials.cfgWsSrAssistenza.id,
                changeInSelf: res.data.authCredentials.changeInSelf
            };
            dispatch({
                type: actionTypes.SET_SELECTED_COMPANY,
                selectedCompany: selectedCompany,
                token: res.data.authCredentials.token,
                frontendConfiguration: res.data.authCredentials.frontendConfiguration,
            })
        }).catch((err) => {
            console.log(err);
            dispatch({
                type: actionTypes.SET_SELECTED_COMPANY,
                selectedCompany: {
                    integrationId: integrationId,
                }
            })
        }).then(() => {
            dispatch(setLoading(false, "liveloAssistenzaLoading"));
        });
    }
}

export const setLoading = (value, name) => {
    return {
        type: actionTypes.SET_LOADING_AUTH,
        value: value,
        name: name
    }
}

export const getContactNumbersForCustomer = (customerId, assistenzaId) => {
    let loading = store.getState().authReducer.loadingContactNumbers
    return dispatch => {
        if (!loading) {
            dispatch({type: actionTypes.SET_LOADING_CONTACT_NUMBERS, loading: true});
            CustomerService.getContactNumbers(customerId, assistenzaId).then(res => {
                dispatch({
                    type: actionTypes.GET_CONTACT_NUMBERS_FOR_CUSTOMER,
                    data: res.data
                });
            }).catch(e => {
                console.log(e);
            })
                .finally(() => {
                    dispatch({type: actionTypes.SET_LOADING_CONTACT_NUMBERS, loading: false});
                })
        }

    }
}

export const clearContactNumbers = () => {
    return ({
        type: actionTypes.CLEAR_CONTACT_NUMBERS
    })
}

export const logoutUser = () => {
    sessionStorage.removeItem(TOKEN_NAME);
    return ({type: actionTypes.LOGOUT_USER})
}

const cacheSimsAndDigitalContract = (dispatch, integrationId) => {
    dispatch({type: actionTypes.CACHE_SIMS_LOADING, payload: true})
    RefreshCacheService.cacheSims(integrationId).finally(() => {
        dispatch({type: actionTypes.CACHE_SIMS_LOADING, payload: false})
    })

    dispatch({type: actionTypes.CACHE_DIGITAL_CONTRACT_LOADING, payload: true})
    RefreshCacheService.cacheDigitalContract(integrationId).finally(() => {
        dispatch({type: actionTypes.CACHE_DIGITAL_CONTRACT_LOADING, payload: false})
    })
}
